import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/folder-upload.svg
 */
const IconFolderUpload: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M13 14.5v-1.625h2L12 9.5l-3 3.375h2V14.5h2zM8 16.5h8v-2h-1v1H9v-1H8v2z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6L8 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2H10zm-2.621-.5l2 2H20a.5.5 0 01.5.5v10a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h3.379z"
      fill="currentColor"
    />
  </svg>
);

export default IconFolderUpload;
